import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import TransferSchedulesList from '~/containers/transferSchedulesList/transferSchedulesList';

export default class TransferSchedulesPage extends Component {
  render() {
    const createButton = (
      <Link to="/settings/transfers/create">
        <Button color="primary">New transfer schedule</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/settings" backText="Settings" title="Transfer Schedules" button={createButton} />
        <TransferSchedulesList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/transferSchedules/transferSchedules.jsx